import { isValuesFromArrayInArray } from './isValuesFromArrayInArray';
import { ROLES_ADMIN } from '../Config/Constants';
import { ROOT_ROUTE_ADMIN, ROOT_ROUTE_MEMBER } from '../Config/Routes';

export const getRootRouteByRole = roles =>
  isValuesFromArrayInArray(roles, ROLES_ADMIN) ? ROOT_ROUTE_ADMIN : ROOT_ROUTE_MEMBER;
